import React from 'react'

export const IconZoom = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M11.007 2a9.007 9.007 0 017.037 14.628L22 20.585 20.585 22l-3.957-3.956A9.007 9.007 0 1111.006 2zm0 2.001a7.005 7.005 0 100 14.01 7.005 7.005 0 000-14.01zM12 6v4h4v2h-4v4h-2v-4H6v-2h4V6h2z"
      />
    </svg>
  )
}
